import React, { useRef } from "react";
import "./section6.css";

export default function Section6() {
  const section6 = useRef(null);
  const onLoad = () => {
    section6.current.style.backgroundImage = 'url("/images/bg2.jpg")';
  };
  return (
    <section ref={section6} className="page-section section6 container-fluid">
      <img
        src="/images/bg2.jpg"
        className="d-none"
        onLoad={onLoad}
        alt="Mehthab Musambil Qoute"
      />
      <div className="container h-100 d-flex flex-column justify-content-center">
        <div className="row justify-content-center">
          <h1
            data-aos="fade-up"
            data-aos-duration="1000"
            className="text-white text-center font-weight-bold display-md-4 display-3"
            style={{ zIndex: 100 }}
          >
            Imagination is more <br className="d-md-inline d-none" /> important
            than knowledge
          </h1>
        </div>
        <div></div>
      </div>
    </section>
  );
}
